import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import {
  OrganizationSwitcher as OrganizationSwitcherComp
} from 'components/misc'
import { setActiveOrganization } from 'redux/modules/auth'
import { getTasksOverview } from 'redux/modules/api/tasks/tasks-overview'
import { modal, onRefreshPage } from 'redux/modules/app'
import { apiOrganizations } from 'helpers/decorators/api'
import { ROLES, USER_TYPES } from 'constants/enums'
import config from 'config'

const enhance = compose(
  apiOrganizations(),
  connect(
    ({ app, auth }) => ({
      user: auth.user,
      activeOrganization: auth.organization,
      isFromLogin: get(app.modal, 'data.isFromLogin') === true
    }),
    { modal, setActiveOrganization, push, getTasksOverview, onRefreshPage }
  )
)

class OrganizationSwitcher extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onRefreshPage: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    setActiveOrganization: PropTypes.func.isRequired,
    getTasksOverview: PropTypes.func.isRequired,
    reloadOrganizationDetail: PropTypes.func.isRequired,
    isFromLogin: PropTypes.bool,
    isGOPEnabled: PropTypes.bool.isRequired
  }

  componentWillReceiveProps(nextProps) {
    const { activeOrganization } = this.props

    if (activeOrganization.id !== nextProps.activeOrganization.id) {
      this.props.reloadOrganizationDetail()
    }
  }

  handleSelect = (
    { userType, name, id, hierarchyLevelType, regionId } = {}
  ) => {
    this.props.setActiveOrganization({
      id,
      name,
      userType,
      hierarchyLevelType,
      regionId
    })

    this.props.modal(null)

    if (userType !== ROLES.IF_STAFF_USER.u) {
      this.props.getTasksOverview(null, { activeOrganizationId: id, awardLeaderId: this.props.user.personId })
    }

    // if (
    //   window.location.pathname === get(USER_TYPES[userType], 'defaultRedirect')
    // ) {
    //   this.props.onRefreshPage(true)
    //   return
    // }

    const path = get(USER_TYPES[userType], 'defaultRedirect', `${config.publicPath}/profile`)
    this.props.push(path)
    this.props.onRefreshPage(true)
  }

  render() {
    const { user, isFromLogin, isGOPEnabled } = this.props

    return (
      <OrganizationSwitcherComp
        user={user}
        modal={this.props.modal}
        onSelect={this.handleSelect}
        isFromLogin={isFromLogin}
        isGOPEnabled={isGOPEnabled}
      />
    )
  }
}

export default enhance(OrganizationSwitcher)
